import { get, post, download, BaseUrl } from './api'

export const getDemoUser = async (environment = null) => {
  return await get(`api/WebEditor/${environment}/demouser`, BaseUrl.Api);
}

export const uploadDxml = async (uploadDxmlModel, environment = null) => {
  return await post(`api/WebEditor/${environment}/upload`, BaseUrl.Api, uploadDxmlModel);
}

export const downloadDxml = async (dxmlUID, environment = null) => {
  return await download(`api/WebEditor/${environment}/download/${dxmlUID}`, `${dxmlUID}.xml`, BaseUrl.Api);
}

export const getOnlineDocuments = async (metaFile, environment = null) => {
  return await get(`api/WebEditor/${environment}/getOnlineDocuments/${metaFile}`, BaseUrl.Api);
}

export const createAndUploadDxml = async (createAndUploadDxmlFileRequest, environment = null) => {
  return await post(`api/WebEditor/${environment}/createAndUploadDxml`, BaseUrl.Api, createAndUploadDxmlFileRequest);
}